export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="max-w-4xl mx-auto bg-background-100 rounded-xl border border-background-200/70 overflow-hidden shadow-sm">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-600 text-xs font-medium mb-4">
                <i className="ri-smartphone-line text-sm" />
                移动端专属体验
              </div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                客户端阅读
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                下载古古漫画网客户端，享受更流畅的下拉式阅读体验。支持离线缓存、夜间模式、更新推送和个性化推荐，让追漫随时随地。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mb-4">
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-foreground-900 text-white text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-fill text-lg" />
                  iOS 版下载
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-fill text-lg" />
                  Android 版下载
                </a>
              </div>
              <p className="text-xs text-foreground-400">
                支持 iOS 15+ · Android 10+ · 纯净无广告
              </p>
            </div>
            <div className="flex-1 flex justify-center p-6 md:p-0 lg:justify-end">
              <div className="relative">
                <div className="w-[210px] h-[380px] md:w-[250px] md:h-[430px] rounded-xl overflow-hidden border-4 border-background-200 shadow-lg">
                  <img
                    src="https://readdy.ai/api/search-image?query=Smartphone%20device%20mockup%20displaying%20colorful%20manga%20webtoon%20reading%20app%20interface%20with%20vertical%20scroll%20mode%2C%20warm%20orange%20and%20cream%20UI%20theme%2C%20Japanese%20Korean%20Chinese%20comic%20art%20on%20screen%2C%20clean%20modern%20app%20design%2C%20soft%20device%20shadow%20on%20light%20background%2C%20minimalist%20phone%20frame%2C%20high%20quality%20digital%20product%20mockup&width=520&height=880&seq=gugu-app-mockup&orientation=portrait"
                    alt="古古漫画网客户端阅读界面展示"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -top-3 -right-3 px-3 py-1.5 rounded-full bg-accent-500 text-white text-xs font-semibold shadow-md whitespace-nowrap">
                  全新 3.0 版本
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}